import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import { Button, createStyles, makeStyles } from "@material-ui/core";
import stylesPc from "../../viewer/UploadSlideStock.module.css";
import stylesSp from "../../viewer/UploadSlideStock_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { Tip } from "../../../models/slides";
import { useInitText } from "../../../components/function/useInitText";
import { useInitFlag } from "../../../components/function/useInitFlag";
import { isEmpty } from "../../../utils/ObjectUtils";
import FList from "./FList";
import { t } from "i18next";

interface TipDetailInfoPrps {
    setIsSaved: (isSaved: boolean) => void;
    pageNumber: number;
    tipLists: Tip[];
    setTipList: (tipLists: Tip[]) => void;
}

function TipDetailInfo({ setIsSaved, pageNumber, tipLists, setTipList }: TipDetailInfoPrps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const useStyles = makeStyles(() =>
        createStyles({
            input: {
                width: "100%",
                "& .MuiOutlinedInput-root": {
                    color: "white",
                    "&.Mui-focused fieldset": {
                        borderColor: "var(--studio-btn-bg)",
                    },
                },
            },
            insertButton: {
                color: "white",
                backgroundColor: "#292E36",
                width: "270px",
                height: "40px",
                boxShadow: "none",
                fontSize: "14px",
                fontFamily: "noto-sans-cjk-jp,sans-serif",
                "&:hover": {
                    width: "270px",
                    height: "40px",
                    boxShadow: "none",
                    backgroundColor: "#333A43",
                },
            },
        })
    );
    const classes = useStyles();

    // Tip description情報
    const [tipdescription, setTipDescription] = useInitText();
    // Tip情報追加・Tip編集ボタンボタン表示判断
    const [isTipEdit, setIsTipEdit] = useInitFlag();
    // Tip追加ボタン活性・非活性用
    const [isTipDisable, setTipDisable] = useInitFlag(true);

    // Tip情報入力値の設定
    const ChangeTipDescription = (event: any) => {
        let currentTip: Tip | undefined;
        setTipDescription(event.target.value);
        // 一つのページには一つのh補足だけつけるの確認
        currentTip = tipLists.find((tip: Tip) => tip.title === pageNumber);
        // 現在のページにチャプターがある場合は、チャプター情報追加ボタンの非活性
        if (currentTip && !isTipEdit) {
            setTipDisable(true);
        } else if (isEmpty(event.target.value)) {
            setTipDisable(true);
        } else {
            setTipDisable(false);
        }
        setIsSaved(false);
    };

    // Tip追加ボタンを押す時
    const addTipBtnClick = () => {
        // 新規Tipを作成
        const tip: Tip = {
            id: 0, // 作成時、default値
            title: pageNumber,
            description: tipdescription,
        };
        // Tipリストに追加
        tipLists.push(tip);
        // Tip順番を並び替え
        sortTip();
        // Tip情報をクリアして追加ボタンを非活性にする
        setTipDescription("");
        setTipDisable(true);
    };

    // Tip順番を並び替え
    const sortTip = () => {
        const sortedTipList = tipLists.sort((tip1, tip2) => {
            return tip1.title - tip2.title;
        });
        // Tip Id順番設定
        for (let i = 0; i < tipLists.length; i++) {
            tipLists[i].id = i;
        }
        setTipList(sortedTipList);
    };

    // Tips description情報編集、現在Tips ID変数定義
    const [currentTip, setCurrentTip] = useState<null | Tip>(null);
    // 編集するTips情報の入力
    const editTip = (id: string) => {
        let tipID = id.replace("tip.", "");
        setTipDescription(tipLists[parseInt(tipID)].description);
        setCurrentTip(tipLists[parseInt(tipID)]);
        setTipDisable(false);
        setIsTipEdit(true);
    };

    // Tip編集ボタンを押す時
    const editTipBtnClick = () => {
        const editTip: Tip[] = [];
        tipLists.forEach((tip: Tip) => {
            if (tip.id === currentTip?.id) {
                tip.description = tipdescription;
            }
            editTip.push(tip);
        });
        // Tipリストに追加
        setTipList(editTip);
        // Tip情報をクリアして追加ボタンを非活性にする
        setTipDescription("");
        setTipDisable(true);
        setIsTipEdit(false);
    };

    // Tip一覧の削除アイコンを押下処理
    const deleteTip = (id: string) => {
        let tipID = id.replace("tip.", "");
        const newList: Tip[] = tipLists.filter((tip: Tip) => tip.id !== parseInt(tipID));

        // Tip一覧表示設定
        setTipList(newList);
        // Index情報をクリアして追加ボタンを非活性にする
        setTipDescription("");
        setTipDisable(true);
        setIsTipEdit(false);
        setIsSaved(false);
    };

    // onMouseEnterイベント
    const onMouseEnter = (id: string) => {
        const currentonMouseEnterId = document.getElementById(id);
        if (currentonMouseEnterId) {
            currentonMouseEnterId.style.backgroundColor = "#FFFFFF";
            currentonMouseEnterId.style.border = "1px solid rgba(0,0,0,0.26)";
        }
    };

    // onMouseLeaveイベント
    const onMouseLeave = (id: string) => {
        const currentonMouseLeaveId = document.getElementById(id);
        if (currentonMouseLeaveId) {
            currentonMouseLeaveId.style.backgroundColor = "#F5F5F5";
            currentonMouseLeaveId.style.border = "1px solid rgba(245,245,245,0.26)";
        }
    };

    return (
        <>
            <div className={styles.chapterlistDiv} style={{ color: "#9c9c9c" }}>
                <img
                    src={require("../../../assets/image/info.svg").default}
                    alt="TipIcon"
                    className={styles.infoIconStyle}
                />
                TIPS
            </div>
            <div className={styles.formDetail}>
                <TextField
                    color="secondary"
                    className={classes.input}
                    multiline
                    id="TipInfo"
                    rows={3}
                    variant="outlined"
                    value={tipdescription}
                    placeholder={String(t("TIPSを入力してください"))}
                    autoComplete="off"
                    onChange={ChangeTipDescription}
                />
            </div>
            <div className={styles.addTipDiv}>
                <Button
                    disabled={isTipDisable}
                    size="small"
                    variant="contained"
                    color="secondary"
                    className={classes.insertButton}
                    onClick={isTipEdit ? editTipBtnClick : addTipBtnClick}
                >
                    {isTipEdit ? t("Tips情報編集") : t("Tips情報追加")}
                </Button>
            </div>
            {/* Tip一覧情報表示 */}
            <div className={styles.tipInfoListDiv}>
                {tipLists != null &&
                    tipLists.map((tip: Tip) => (
                        <div>
                            {/* 補足一覧で内容・削除アイコン表示 */}
                            <FList
                                id={`tip.${String(tip.id)}`}
                                slideTitle={`P.${tip.title}`}
                                description={tip.description}
                                style={{
                                    border: "1px solid rgba(245,245,245,0.26)",
                                    overflowY: "auto",
                                    width: "100%",
                                    backgroundColor: "#F5F5F5",
                                    borderRadius: "5px",
                                    marginBottom: "5px",
                                }}
                                deleteClick={deleteTip}
                                editClick={editTip}
                                onMouseEnter={() => onMouseEnter(`tip.${String(tip.id)}`)}
                                onMouseLeave={() => onMouseLeave(`tip.${String(tip.id)}`)}
                            />
                        </div>
                    ))}
            </div>
        </>
    );
}

export default TipDetailInfo;
